import React, { Fragment, useEffect, useState } from 'react';
import {
    ActionIcon,
    Box,
    Container,
    Flex,
    Grid,
    ScrollArea,
    Text,
    TextInput,
    Tooltip
} from '@mantine/core';
import { useDispatch, useSelector } from "react-redux";
import { fetchAllTags } from "../Settings/store/tagSlice";
import MyTaskList from "./MyTaskList";
import { fetchTasksByUser, setLoggedInUserId, updateColumns } from "../Settings/store/myTaskSlice";
import QuickTaskList from "./QuickTaskList";
import { fetchQuickTasksByUser } from "../Settings/store/quickTaskSlice";
import { IconRefresh, IconSearch, IconX } from "@tabler/icons-react";
import { updateIsLoading } from "../Settings/store/taskSlice";
import { translate } from '../../utils/i18n';

const MyTask = () => {

    const dispatch = useDispatch();
    const { loggedUserId } = useSelector((state) => state.auth.user);
    const [searchInputValue, setSearchInputValue] = useState('');

    useEffect(() => {
        setTimeout(() => {
            if (loggedUserId) {
                dispatch(fetchTasksByUser({ id: loggedUserId })).then((response) => {
                    dispatch(updateColumns(response.payload.data && response.payload.data.tasks ? response.payload.data.tasks : {}))
                })
                dispatch(fetchQuickTasksByUser({ id: loggedUserId }))
                dispatch(fetchAllTags())
                dispatch(setLoggedInUserId(loggedUserId))
            }
        }, 500);
    }, [dispatch, loggedUserId]);
    const handleRefresh = () => {
        dispatch(updateIsLoading(true))
    }

    const searchHandler = (e) => {

        const searchValue = e.target.value;
        setSearchInputValue(searchValue);
        dispatch(fetchTasksByUser({ id: loggedUserId, data: { search: searchValue } })).then((response) => {
            dispatch(updateColumns(response.payload.data && response.payload.data.tasks ? response.payload.data.tasks : {}))
        })

    }

    const handleClearSearch = () => {
        setSearchInputValue('');
        dispatch(fetchTasksByUser({ id: loggedUserId, data: { search: '' } })).then((response) => {
            dispatch(updateColumns(response.payload.data && response.payload.data.tasks ? response.payload.data.tasks : {}))
        })
    };

    return (
        <Fragment>

            <div className='dashboard'>
                <Container size="full">

                    <div className="settings-page-card rounded-xl mt-5">
                        <Grid columns={12} className="pb-3">
                            <Grid.Col span={9}>
                                <Box bg={"white"} p={20} m={5} radius="xl" className="rounded-xl">
                                    <Flex className='mt-2 mb-4' align="center" justify="space-between">
                                        {/* Title pill */}
                                        <Flex
                                            align="center"
                                            gap={6}
                                            className="px-3 py-1.5 rounded-full"
                                            style={{ backgroundColor: '#EBF1F4' }}
                                        >
                                            <Text fw={600} size="sm" c="#39758D">
                                                {translate('My Tasks')}
                                            </Text>
                                        </Flex>

                                        {/* Search & Refresh */}
                                        <Flex align="center" gap={8}>
                                            <TextInput
                                                value={searchInputValue}
                                                rightSectionPointerEvents="auto"
                                                rightSection={
                                                    searchInputValue ? (
                                                        <IconX
                                                            size={18}
                                                            stroke={1.5}
                                                            className="cursor-pointer text-gray-400"
                                                            onClick={handleClearSearch}
                                                        />
                                                    ) : (
                                                        <IconSearch size={18} stroke={1.5} className="text-gray-400" />
                                                    )
                                                }
                                                onChange={(e) => { searchHandler(e) }}
                                                placeholder={translate('Search...')}
                                                size="sm"
                                                radius="xl"
                                                styles={{
                                                    input: {
                                                        border: '1px solid #D1D5DB',
                                                        minWidth: '220px',
                                                        '&:focus': {
                                                            borderColor: '#39758D',
                                                        }
                                                    }
                                                }}
                                            />
                                            <Tooltip label={translate('Refresh')} position="top" withArrow>
                                                <ActionIcon
                                                    onClick={() => handleRefresh()}
                                                    variant="subtle"
                                                    color="gray"
                                                    radius="xl"
                                                    size="lg"
                                                    aria-label="Refresh"
                                                    className="hover:bg-[#EBF1F4] transition-colors"
                                                >
                                                    <IconRefresh size={20} stroke={1.5} color="#6B7280" />
                                                </ActionIcon>
                                            </Tooltip>
                                        </Flex>
                                    </Flex>
                                    <div className="w-full bg-white">
                                        <MyTaskList />
                                    </div>
                                </Box>
                            </Grid.Col>
                            <Grid.Col span={3} className="mt-1">
                                <QuickTaskList />
                            </Grid.Col>
                        </Grid>
                    </div>
                </Container>
            </div>

        </Fragment>

    );
}

export default MyTask;
